export const CHANGE_APP_PROPS = "CHANGE_APP_PROPS";
export const MODE_CRU_UPDATE = "UPDATE";
export const MODE_CRU_CREATE = "CREATE";
export const MODE_CRU_SHOW = "SHOW";
export const LOGIN_USER = "LOGIN_USER";
export const CHANGE_PROPS_RECOVERY_PASSWORD = "CHANGE_PROPS_RECOVERY_PASSWORD";
export const CHANGE_LOCATION_PROPS = "CHANGE_LOCATION_PROPS";
export const CHANGE_DECLARACION_JURADA_PROPS =
	"CHANGE_DECLARACION_JURADA_PROPS";
export const CHANGE_DATA_PROPS = "CHANGE_DATA_PROPS";
export const CHANGE_AFILIADO_PROPS = "CHANGE_AFILIADO_PROPS";
export const CHANGE_BOLETA_PROPS = "CHANGE_BOLETA_PROPS";
export const CHANGE_EMPRESA_PROPS = "CHANGE_EMPRESA_PROPS";
export const CHANGE_HOLIDAY_PROPS = "CHANGE_HOLIDAY_PROPS";
export const CHANGE_FIXED_CONTRIBUTION_PROPS =
	"CHANGE_FIXED_CONTRIBUTION_PROPS";
export const CHANGE_USER_CONTROL_PROPS = "CHANGE_USER_CONTROL_PROPS";
export const CHANGE_MEDIA_PROPS = "CHANGE_MEDIA_PROPS";
export const CHANGE_BI_MODEL_PROPS = "CHANGE_BI_MODEL_PROPS";
export const CHANGE_PAYMENT_METHOD_PROPS = "CHANGE_PAYMENT_METHOD_PROPS";
export const CHANGE_SALARY_PROPS = "CHANGE_SALARY_PROPS";
export const CHANGE_SUPPORT_TICKET_PROPS = "CHANGE_SUPPORT_TICKET_PROPS";



// WEBPACK FOOTER //
// ./src/actions/ActionConstants.js